module.exports = __webpack_public_path__ + "img/teachersCollageCopy.7d9b59ac.webp";